import React from "react";
import { Input, FormControl, FormLabel } from "@chakra-ui/react";

import { Field, getIn } from "formik";

const CustomArrayInput = ({
  name,
  label,
  placeholder,
  maxLength,
  onChange,
}) => (
  <Field name={name}>
    {({ field, form }) => {
      const error = getIn(form.errors, name);
      const touch = getIn(form.touched, name);

      return (
        <FormControl id={name} isInvalid={touch && error}>
          <FormLabel
            color="#5F6377"
            fontWeight="500"
            fontSize="14px"
            lineHeight="19.6px"
            htmlFor={name}
          >
            {label}
          </FormLabel>
          <Input
            {...field}
            h="42px"
            name={name}
            id={name}
            backgroundColor="#fff"
            autoComplete="off"
            border="1px solid #D7D8DE"
            placeholder={placeholder}
            maxLength={maxLength ? maxLength : null}
            onChange={onChange ? onChange : field.onChange}
          />
        </FormControl>
      );
    }}
  </Field>
);

export default CustomArrayInput;
